export var TriggerType;
(function (TriggerType) {
    TriggerType["Scheduled"] = "scheduled";
    TriggerType["Scenario"] = "scenario";
    TriggerType["Execute"] = "execute";
    TriggerType["ExecuteDefinition"] = "execute-definition";
    TriggerType["ExecuteBulk"] = "execute-bulk";
    TriggerType["Resume"] = "resume";
    TriggerType["EventProcessor"] = "event-processor";
})(TriggerType || (TriggerType = {}));
//# sourceMappingURL=flowTriggerLog.js.map